module.exports = __webpack_public_path__ + "media/assets/icons/ic-wallet-filled-320df29059a6df695da6d4188e5af191.svg";